export interface CustomLibraryItem {
  id: string;
  label: string;
  url: string;
}

export interface DesignToolsPublicSettings {
  rulers_enabled: boolean;
  hidden_shape_ids: string[];
  hidden_emoji_slugs: string[];
  hidden_emoji_groups: string[];
  customShapes: CustomLibraryItem[];
  customEmoji: CustomLibraryItem[];
}

function defaults(): DesignToolsPublicSettings {
  return {
    rulers_enabled: true,
    hidden_shape_ids: [],
    hidden_emoji_slugs: [],
    hidden_emoji_groups: [],
    customShapes: [],
    customEmoji: [],
  };
}

function veyopRootUrl(): string {
  const configEl = document.getElementById('designer-config');
  try {
    const config = JSON.parse(configEl?.textContent || '{}');
    const root = String(config.veyopUrl || '').replace(/\/$/, '');
    if (root) return root;
  } catch {
    // Fall through to origin-based default.
  }
  return (window as Window & { VeyopHostConfig?: { baseUrl?: string } }).VeyopHostConfig?.baseUrl || window.location.origin;
}

let cached: Promise<DesignToolsPublicSettings> | null = null;

export function fetchPublicSettings(): Promise<DesignToolsPublicSettings> {
  if (!cached) {
    const portable = (window as Window & { Veyop?: { http?: { request<R>(path: string, options?: RequestInit): Promise<R> } } }).Veyop?.http;
    cached = (portable
      ? portable.request<DesignToolsPublicSettings>('/api/v1/design_tools/settings')
      : fetch(`${veyopRootUrl()}/api/v1/design_tools/settings`, { credentials: 'same-origin' })
      .then((response) => (response.ok ? response.json() : Promise.reject(new Error(`Request failed (${response.status})`))))
      .then((payload) => payload?.data ?? {}))
      .then((payload) => ({ ...defaults(), ...payload }))
      .catch(() => defaults());
  }
  return cached;
}
